import React from 'react'

const URL_PATTERN = /((?:https?:\/\/|www\.)[^\s<>"]+)/gi
const TRAILING_PUNCTUATION = /[.,;:!?'"]+$/

const splitTrailing = (match) => {
  let url = match
  let trailing = ''

  const punctuation = url.match(TRAILING_PUNCTUATION)
  if (punctuation) {
    trailing = punctuation[0]
    url = url.slice(0, -trailing.length)
  }

  while (url.endsWith(')') && (url.match(/\(/g) || []).length < (url.match(/\)/g) || []).length) {
    trailing = `)${trailing}`
    url = url.slice(0, -1)
  }

  return [url, trailing]
}

export default function LinkifiedText({ text, className = '', linkClassName = '' }) {
  if (text === null || text === undefined || text === '') return null

  const parts = String(text).split(URL_PATTERN)

  return (
    <span className={`whitespace-pre-wrap [overflow-wrap:anywhere] ${className}`}>
      {parts.map((part, index) => {
        if (index % 2 === 0) return part

        const [url, trailing] = splitTrailing(part)
        const href = /^https?:\/\//i.test(url) ? url : `https://${url}`

        return (
          <React.Fragment key={index}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={e => e.stopPropagation()}
              className={`text-rb-green underline underline-offset-2 hover:opacity-80 ${linkClassName}`}
            >
              {url}
            </a>
            {trailing}
          </React.Fragment>
        )
      })}
    </span>
  )
}
